import styles from 'styles/Icon.module.css'

const Icon = ({ children }) =>
    <i className={`material-icons ${styles.i}`}>{ children }</i>

export default Icon